/*
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:14
 * @LastEditTime: 2023-05-31 18:00:08
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/store/config.js
 */
import { defineStore } from 'pinia'
import { THEME_LIGHT, THEME_VALUES } from '@/hook/useAppColorMode.js'
import {
  addLocalePrefix,
  canonicalizeLocaleTarget,
  getCurrentLocale,
} from '@/utils/localeRoute.js'

const useConfigStore = defineStore('configStore', {
  state: () => {
    const winLocale = getCurrentLocale({
      path: window.location.pathname,
      fallbackLocale: getUrlQuery().locale,
    })
    const tradeStyleMap = {
      'trade-style-0': 'trade-style-0',
      'trade-style-1': 'trade-style-1',
    }
    const tradeStyleDefault = tradeStyleMap[Object.keys(tradeStyleMap)[0]]
    const tradeStyleKeys = Object.keys(tradeStyleMap)
    const tradeStyle = tradeStyleKeys.find(e => e == localStorage.tradeStyle) ? localStorage.tradeStyle : tradeStyleDefault
    localStorage.tradeStyle = tradeStyle
    const themePreference = localStorage.theme ?? THEME_LIGHT
    return {
      theme: themePreference, // 当前生效主题
      themePreference: themePreference, // 用户偏好主题
      locale: winLocale,
      tradeStyleMap: tradeStyleMap,
      tradeStyle: tradeStyle,
      tradeStyleDefault: tradeStyleDefault,
      logStatus: 1,
      languageMap: [
        {
          label: '简体中文',
          value: LANGCN,
        },
        {
          label: 'English',
          value: LANGEN,
        },
        {
          label: '繁體中文',
          value: LANGTW,
        },
        {
          label: '日本語',
          value: LANGJA,
        },
        {
          label: '한국어',
          value: LANGKO,
        },
      ]
    }
  },
  getters: {
    languageName: (state) => state.languageMap.find(item => item.value == state.locale)?.label,
    tradeStyleIsDefault: (state) => state.tradeStyle == state.tradeStyleDefault
  },
  actions: {
    async getMonitorLogStatus () {
      const d = await configApi.getMonitorLogStatus()
      this.logStatus = d
    },
    // 切换用户显式选择的主题。
    // 这里会同时更新：
    // 1. themePreference: 用户偏好的主题，后续持久化到 localStorage
    // 2. theme: 当前页面立即生效的主题
    // 适合“用户主动切换明暗主题”这种场景。
    setTheme (value) {
      const nextTheme = THEME_VALUES.includes(value) ? value : THEME_LIGHT
      this.themePreference = nextTheme
      this.theme = nextTheme
    },
    setResolvedTheme (value) {
      this.theme = THEME_VALUES.includes(value) ? value : THEME_LIGHT
    },
    // 切换站点语言。
    async setLanguage (value) {
      if (this.locale === value) {
        return
      }
      await $t.changeLange(value)
      this.locale = value

      const currentRoute = router.currentRoute.value
      const target = canonicalizeLocaleTarget({
        path: currentRoute?.path || window.location.pathname,
        query: currentRoute?.query || getUrlQuery(),
        hash: currentRoute?.hash || window.location.hash,
        fallbackLocale: value,
      })

      const nextPath = addLocalePrefix(target.businessPath, value)
      if (currentRoute?.path !== nextPath || JSON.stringify(currentRoute?.query || {}) !== JSON.stringify(target.query) || (currentRoute?.hash || '') !== target.hash) {
        await router.replace({
          path: nextPath,
          query: target.query,
          hash: target.hash,
        })
      }
    },
    async setTradeStyle (value) {
      const tradeStyleMap = {
        'trade-style-0': 0,
        'trade-style-1': 1,
      }
      this.tradeStyle = value
      localStorage.tradeStyle = value
      configApi.switchTheme({ theme: tradeStyleMap[value] })
    },
    async tradeStyleSwitch () {
      let v
      if (this.tradeStyle == 'trade-style-0') {
        v = 1
      } else if (this.tradeStyle == 'trade-style-1') {
        v = 0
      }
      this.tradeStyle = `trade-style-${v}`
      configApi.switchTheme({ theme: v })
    }
  },
  init () {
    const HTMLDom = document.querySelector('html')
    HTMLDom.classList.add(`app-language-${this.locale}`)
    this.$subscribe((mutation, state) => {
      localStorage.theme = state.themePreference
      localStorage.tradeStyle = state.tradeStyle
      localStorage.locale = state.locale
    })
  },
})

export default useConfigStore
